import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "store/store";

/**
 * Updates page title in browser tab.
 */
const usePageTitle = (title: string, extra: string = "") => {
    const { companySettings } = useAppSelector((state) => state.settings);
    const { title: currentTitle } = useAppSelector((state) => state.titles);
    const { beneficiar: currentBeneficiar } = useAppSelector((state) => state.beneficiary);
    const [pageTitle, setPageTitle] = useState(`${companySettings?.name ?? ""} › ${title}${extra} - Crealo`);
    const [cachedTitleName, setCachedTitleName] = useState(currentTitle?.name || "");
    const location = useLocation().pathname;
    const isTitlePage =
        (location.startsWith("/titles") && !location.includes("connect-beneficiar")) ||
        location.startsWith("/publications");
    const isBeneficiarPage = location.startsWith("/beneficiars") && !location.includes("connect-title");

    useEffect(() => {
        if (companySettings) document.title = pageTitle;
        else document.title = "Crealo";

        return () => {
            document.title = "Crealo";
        };
    }, [pageTitle]);

    useEffect(() => {
        if (companySettings?.name) setPageTitle(`${companySettings?.name ?? ""} › ${title}${extra} - Crealo`);
    }, [companySettings, extra]);

    useEffect(() => {
        if (isTitlePage) {
            setPageTitle(
                `${companySettings?.name ?? ""} › ${title} › "${currentTitle?.name || cachedTitleName || ""}" - Crealo`,
            );
            setCachedTitleName(currentTitle?.name ?? "");
        }
    }, [isTitlePage, currentTitle]);

    useEffect(() => {
        if (isBeneficiarPage)
            setPageTitle(
                `${companySettings?.name ?? ""} › ${title} › ${
                    currentBeneficiar?.name + " " + currentBeneficiar?.surname || ""
                } - Crealo`,
            );
    }, [isTitlePage, currentBeneficiar]);
};

export default usePageTitle;
